import Form from "@/components/Form";
import { SubmitHandler } from "react-hook-form";
import { useDictionaryContext } from "@/components/dictionaries/DictionaryContext";
import { ReadonlyObject } from "@/types/readOnly";
import { PropsWithChildren } from "react";

const DictionaryForm = <TRead extends ReadonlyObject, TWrite extends object>({
  children,
}: PropsWithChildren) => {
  const { mutation, form } = useDictionaryContext<TRead, TWrite>();
  const handleSubmit: SubmitHandler<TWrite> = async (values) => {
    await mutation.mutateAsync(values);
  };

  return (
    <Form form={form} handleSubmit={handleSubmit}>
      {children}
    </Form>
  );
};

export default DictionaryForm;
